export class DynamicFilter {
  public filterName: string;
  public values: any = [];

  constructor(filterName = '') {
    this.filterName = filterName;
  }
}
